import React from "react"
import { Flex, Box } from "@rebass/grid/emotion"

import Section from "../section/section"
import ProductCard from "./productcard"
import ProductReferenceTwo from "../gwp/productreferencetwo/productreferencetwo"

import { TextElementNova } from "@nutrafol/nutrafol-ui-kit/dist/TextElementNova"

import { ProductSectionWrap, GwpColumnFlex } from "./products.styled"

const ProductSection = ({ data }) => {
  const { heading, image, products } = data

  return (
    <ProductSectionWrap>
      <picture>
        <source media="(max-width: 767px)" srcSet={image.mobile} />
        <source
          media="(min-width:768px) and (max-width:1023px)"
          srcSet={image.tablet}
        />
        <source media="(min-width: 1024px)" srcSet={image.desktop} />
        <img
          src={image.desktop}
          alt=""
          role="presentation"
          className={`block sm:hidden md:block rounded rounded-b-none`}
        />
      </picture>
      <Section className="product-section-wrap" as="div">
        <img
          src={image.tablet}
          alt=""
          role="presentation"
          className="hidden sm:block md:hidden"
        />
        {data?.gwpColumn ? (
          <GwpColumnFlex
            width={1}
            px={16}
            pt={[24, null, null, null, 40]}
            className="sm:border-l sm:border-r md:border-0 border-nova-transparency-black-20 bg-nova-base-white relative md:rounded md:rounded-b-none text-center"
          >
            <TextElementNova
              text={heading}
              element="h2"
              className="Title-20-Super-Normal text-center pb-[10px] sm:pb-0"
            />
            <ProductReferenceTwo data={data.gwpColumn} />
          </GwpColumnFlex>
        ) : (
          <Box
            width={1}
            px={16}
            py={24}
            className="sm:border-l sm:border-r md:border-0 border-nova-transparency-black-20 bg-nova-base-white relative md:rounded md:rounded-b-none"
          >
            <TextElementNova
              text={heading}
              element="h2"
              className="Title-20-Super-Normal text-center"
            />
          </Box>
        )}
        <Flex flexWrap="wrap" className="bg-nova-base-white relative">
          {products.map((product, i) => {
            return (
              <React.Fragment key={i}>
                <ProductCard product={product} index={i} />
              </React.Fragment>
            )
          })}
        </Flex>
      </Section>
    </ProductSectionWrap>
  )
}

export default ProductSection
